export function isAndroidOrIos() {
    var u = navigator.userAgent;
    if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        return 'android'
    }
    if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        return 'ios'
    }
    return 'web'
}
// 判断是否是百度浏览器
export function inBaiduBrowser() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  if(sUserAgent.indexOf("baidu") > 0) {
    return true
  }
  return false
}
/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
    newArray.push(actual[i])
    }
  }
  return newArray
}
  
/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}
/**
 * 格式化价格
 * @param {*} price 分
 */
export function money(price){
  return (parseInt(price)/100).toFixed(2)
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

export function analogJump(path, query, isVuePath){
  if (isVuePath) {
    let url = location.href.slice(0, location.href.indexOf('#'))
    // var params = getQueryObject(url)
    const random = new Date().getTime()
    path = url.substring(0, url.indexOf('?'))+'?'+param({random: random})+'#'+path+(query?'?'+param(query):'')
  } else if(query){
    const params = getQueryObject(path)
    query = Object.assign(query, params)
    path = path.substring(0, path.lastIndexOf('?'))+'?'+param(query)
  }
  var dom = document.createElement('a')
  dom.href = path
  dom.click()
}

export function substring(str, len, hasDot){
  if(!str){
    return str
  }
  var newLength = 0; 
  var newStr = ""; 
  var chineseRegex = '/[^\x00-\xff]/g'; 
  var singleChar = ""; 
  var strLength = str.replace(chineseRegex,"**").length; 
  for(var i = 0;i < strLength;i++) 
  { 
    singleChar = str.charAt(i).toString(); 
    if(singleChar.match(chineseRegex) != null) 
    { 
      newLength += 2; 
    }     
    else 
    { 
      newLength++; 
    } 
    if(newLength > len) 
    { 
      break; 
    } 
    newStr += singleChar;
  }
  if(hasDot && strLength > len) 
  { 
    newStr += "..."; 
  }
  return newStr; 
}

//判断是否微信登陆
export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
  } else {
      return false;
  }
}

// 格式化时分秒
export function formatTime(time){
  var date = ''
  var h = Math.floor(time/3600)
  if( h !== 0){
    date += (h>9?h:'0'+h)+':';
  }
  time = time%3600
  var i = Math.floor(time/60)
  if(i !== 0){
    date += (i>9?i:'0'+i)+':';
  }else{
    date += '00:'
  }
  time = Math.floor(time%60)
  if(time !== 0){
    date += time>9?time:'0'+time;
  }else{
    date += '00'
  }
  return date
}

export function substringKeepHtml(str, len, hasDot){
  if(!str){
    return str
  }
  var newLength = 0; 
  var newStr = ""; 
  var chineseRegex = '/[^\x00-\xff]/g'; 
  var singleChar = ""; 
  var strLength = str.replace(chineseRegex,"**").length; 

  let doms = [];
  let indom = 0; // 判断是否在标签里面 0 不在 < 1 / 2 当出现>,且indom=1 push indom=2 pop
  for(var i = 0;i < strLength;i++) { 
    singleChar = str.charAt(i).toString(); 
    if(singleChar.match(chineseRegex) != null) { 
      newLength += 2; 
    } else {
      if(singleChar === '<'){
        indom = 1
      }else if(indom == 1 && singleChar == '/'){
        indom = 2
      }else if(indom != 0 && singleChar == '>'){
        if(indom == 1){
          doms.push(1)
        }else{
          doms.pop()
        }
        indom = 0
      }else if(indom === 0){
        newLength++;
      }
    }
    if(newLength > len && doms.length === 0) { 
      break; 
    } 
    newStr += singleChar;
  }
  if(hasDot && strLength > len) { 
    newStr += "..."; 
  }
  return newStr; 
}